 function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }import styled from '@emotion/styled'
import graphql from 'babel-plugin-relay/macro'
import React from 'react'
import {useFragment} from 'react-relay'
import SetDefaultSlackChannelMutation from '~/mutations/SetDefaultSlackChannelMutation'
import LabelHeading from '../../../../components/LabelHeading/LabelHeading'

import StyledError from '../../../../components/StyledError'
import useAtmosphere from '../../../../hooks/useAtmosphere'
import useEventCallback from '../../../../hooks/useEventCallback'
import useMutationProps from '../../../../hooks/useMutationProps'
import useSlackChannels from '../../../../hooks/useSlackChannels'
import SetSlackNotificationMutation from '../../../../mutations/SetSlackNotificationMutation'
import {PALETTE} from '../../../../styles/paletteV3'
import {Layout} from '../../../../types/constEnums'




import SlackChannelPicker from './SlackChannelPicker'
import SlackNotificationRow from './SlackNotificationRow'

const SlackNotificationListStyles = styled('div')({
  borderTop: `1px solid ${PALETTE.SLATE_300}`,
  padding: Layout.ROW_GUTTER
})






const TeamGroup = styled('div')({
  alignItems: 'center',
  display: 'flex',
  paddingBottom: 16
})

const UserGroup = styled(TeamGroup)({
  paddingTop: 32
})

const Heading = styled(LabelHeading)({
  width: '100%'
})

const TEAM_EVENTS = [
  'meetingStart',
  'meetingEnd',
  'MEETING_STAGE_TIME_LIMIT_START',
  'STANDUP_RESPONSE_SUBMITTED'
] 
const USER_EVENTS = ['MEETING_STAGE_TIME_LIMIT_END'] 

const SlackNotificationList = (props) => {
  const {teamId, viewer: viewerRef} = props
  const viewer = useFragment(
    graphql`
      fragment SlackNotificationList_viewer on User {
        ...SlackNotificationRow_viewer
        teamMember(teamId: $teamId) {
          integrations {
            slack {
              botAccessToken
              isActive
              slackUserId
              defaultTeamChannelId
              notifications {
                channelId
                event
                eventType
              }
            }
          }
        }
      }
    `,
    viewerRef
  )
  const {teamMember} = viewer
  const {integrations} = teamMember
  const {slack} = integrations
  const notifications = _nullishCoalesce(_optionalChain([slack, 'optionalAccess', _ => _.notifications]), () => ( []))
  const channels = useSlackChannels(slack)
  const {submitting, onError, onCompleted, submitMutation, error} = useMutationProps()
  const atmosphere = useAtmosphere()
  const localPrivateChannel = channels.find((channel) => channel.name === '@Parabol')
  const localPrivateChannelId = localPrivateChannel && localPrivateChannel.id
  const {isActive, defaultTeamChannelId} = slack

  const changeTeamChannel = useEventCallback(
    (slackChannelId) => () => {
      // only change the active events
      const slackNotificationEvents = notifications
        .filter((notification) => notification.channelId && notification.eventType === 'team')
        .map(({event}) => event)
      if (
        submitting ||
        defaultTeamChannelId === slackChannelId ||
        slackNotificationEvents.length === 0
      ) {
        return
      }
      submitMutation()
      SetDefaultSlackChannelMutation(
        atmosphere,
        {slackChannelId: slackChannelId, teamId},
        {
          onError,
          onCompleted
        }
      )
      SetSlackNotificationMutation(
        atmosphere,
        {slackChannelId, slackNotificationEvents, teamId},
        {
          onError,
          onCompleted
        }
      )
    }
  )

  return (
    React.createElement(SlackNotificationListStyles, null
      , React.createElement(TeamGroup, null
        , React.createElement(Heading, null, "Team Notifications" )
        , React.createElement(SlackChannelPicker, {
          channels: channels,
          isTokenValid: isActive,
          localChannelId: defaultTeamChannelId,
          onClick: changeTeamChannel,
          teamId: teamId,}
        )
      )
      , error && React.createElement(StyledError, null, error.message)
      , TEAM_EVENTS.map((event) => {
        return (
          React.createElement(SlackNotificationRow, {
            key: event,
            event: event,
            localChannelId: defaultTeamChannelId,
            teamId: teamId,
            viewer: viewer,}
          )
        )
      })
      , React.createElement(UserGroup, null
        , React.createElement(Heading, null, "Private Notifications" )
        , '@Parabol'
      )
      , error && React.createElement(StyledError, null, error.message)
      , localPrivateChannelId &&
        USER_EVENTS.map((event) => {
          return (
            React.createElement(SlackNotificationRow, {
              key: event,
              event: event,
              localChannelId: localPrivateChannelId,
              teamId: teamId,
              viewer: viewer,}
            )
          )
        })
    )
  )
}

export default SlackNotificationList
